<template>
  <el-dialog
    class="dialog"
    title="群发名单管理"
    width="1100px"
    :visible.sync="showCenterPersonManage.flag"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    distroy-on-close
  >
    <search ref="search" class="search-rect" @search="searchHandle" :mqInfoType="mqInfoType" />
    <div class="main-contant">
      <div class="right-table">
        <el-table
          ref="pageListTable"
          border
          :data="tableData"
          :row-key="getRowKeys"
          :row-style="{ color: '#51627D', fontWeight: 400 }"
          :header-cell-style="{
            background: '#DCE7FA',
            color: '#343C4A',
            fontWeight: 500,
          }"
          @selection-change="handleSelectionChanges"
        >
          <el-table-column
            type="selection"
            :reserve-selection="true"
            width="40"
          >
          </el-table-column>
          <el-table-column
            prop="userName"
            label="学员姓名"
            show-overflow-tooltip
            width="160"
          >
          </el-table-column>
          <el-table-column
            prop="deptName"
            label="工作单位"
            show-overflow-tooltip
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="unitPosition"
            label="单位及职务"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="sizeChange"
          @current-change="pageChange"
          :current-page="currentPage"
          :page-size="size"
          :page-sizes="[10, 50, 100, 500, 1000]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
          hide-on-single-page
        />
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel" size="small">取消</el-button>
      <el-button type="primary" size="small" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Search from "./centerSCSearch.vue";
import { getMqSendUserDraftList } from "@/api/massMessage";
import { filterLevelCode } from "@/utils/common.js";
import { tamePage } from "@/api/enrollOffline";

export default {
  components: {
    Search,
  },
  props: {
    showCenterPersonManage: {
      type: Object,
      default: () => {
        return {
          flag: false,
        };
      },
    },
    // 关联申报
    mqInfoType: {
      type: Number,
      default: 0,
    },
    classId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      getRowKeys(row) {
        return row.uuid;
      },
      selectedMembers: [],
      tableData: [],
      deptId: "",
      total: 0,
      currentPage: 1,
      size: 10,
      userIdList: new Set(),
      nowPageIds: [],
      hasIds: [],
      originListSet: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    cancel() {
      this.$emit("closeCenterManage");
    },
    handleSelectionChanges(rows) {
      // 并集
      let union = [...this.originListSet, ...rows];
      for (let i = 0, len = this.originListSet.length; i < len; i++) {
        for (let j = 0, length = rows.length; j < length; j++) {
          if (this.originListSet[i].uuid === rows[j].uuid) {
            union.splice(
              union.findIndex(
                (item) => item.uuid === this.originListSet[i].uuid
              ),
              1
            );
          }
        }
      }
      this.selectedMembers = union;
    },
    pageChange(page) {
      this.currentPage = page;
      this.getList(this.$refs.search.filters);
    },
    sizeChange(size) {
      this.size = size;
      this.getList(this.$refs.search.filters);
    },
    selectInit(row) {
      if (this.hasIds.length > 0) {
        return !this.hasIds.includes(row.uuid);
      }
      return true;
    },
    // 历史选中回显置灰
    getList(param = {}) {
      let params = {
        page: this.currentPage,
        limit: this.size,
        classId: this.classId, // 中组部选调班id
        isSure: 1 // 是否只显示确定人选（其他或不填：全部 1：只看确定人选）
      };
      tamePage({
        ...params,
        ...param,
      }).then(({ code, data }) => {
        if (code !== 0) return;
        this.handleData(data);
      });
    },
    handleData(data) {
      let { records, total } = data;
      this.tableData = records;
      this.total = total;
      this.nowPageIds = this.tableData.map((x) => x.uuid);
      let rows = [];
      this.selectedMembers.map((x) => {
        this.userIdList.add(x.uuid);
      });
      this.nowPageIds.forEach((x, i) => {
        if (Array.from(this.userIdList).includes(x)) {
          rows.push(this.tableData[i]);
        }
      });
      setTimeout(() => {
        rows.forEach((row) => {
          this.$refs.pageListTable.toggleRowSelection(row, true);
        });
      }, 200);
    },
    // 条件筛选
    searchHandle(data) {
      this.currentPage = 1;
      this.getList(data);
    },
    confirm() {
      if (this.selectedMembers.length > 0) {
        let sendList = [];
        let params = {
          classEnrollList: this.selectedMembers
        };
        getMqSendUserDraftList({
          ...params
        }).then(({ code, data }) => {
          if (code !== 0) return;
          sendList = data; // 获取消息发送名单
          this.$emit("closeCenterManage");
          this.$emit("addSucceed", sendList);
        });
      } else {
        this.$message.error("请选择学员！");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main-contant {
  display: flex;
  min-height: 500px;
}
.right-table {
  flex: 1;
}
.search-rect {
  text-align: right;
}
.pagination {
  float: right;
}
$text-color: #51627d;
$text-font: 14px;
@mixin text {
  color: $text-color;
  font-size: $text-font;
}
@mixin border {
  border: 1px solid #d7dbe0;
  border-radius: 2px;
}
@mixin panel {
  width: 48%;
  height: 300px;
  box-sizing: border-box;
  overflow: hidden;
}
.dialog {
  /deep/ .el-dialog__body {
    max-height: auto;
    .right-panel {
      float: right;
      @include border;
      @include panel;
    }
    .panel-header {
      background-color: #f2f3f4;
      height: 44px;
      display: flex;
      padding: 0 15px;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      & > span:first-child {
        @include text;
      }
    }
  }
}
</style>
